import { Component } from '@angular/core';

@Component({
  selector: 'app-privacy-policy-content',
  standalone: true,
  imports: [],
  templateUrl: './privacy-policy-content.component.html',
  styleUrl: './privacy-policy-content.component.scss'
})
export class PrivacyPolicyContentComponent {

}
